import type { Session } from '@supabase/supabase-js';
import { createContext, use } from 'react';

export interface AuthState {
  status: 'loading' | 'signed-in' | 'signed-out';
  session: Session | null;
  /** The last sign-in or sign-out problem, in words a person can act on. */
  error: string | null;
  /** Desktop only: the system browser is open on Google's sign-in page. */
  waitingForBrowser: boolean;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  /** Signs in with Google again, asking for Drive (drive.file), and hands the refresh token to the `google` function. */
  connectDrive: () => Promise<void>;
  /** Where Connect Google Drive is up to. */
  drive: { status: 'idle' | 'connecting' | 'connected' | 'error'; error: string | null };
}

/** Where a browser sign-in should land afterwards (Connect Google Drive goes back to Vault). */
export const RETURN_TO_KEY = 'hive.returnTo';

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const auth = use(AuthContext);
  if (!auth) throw new Error('useAuth must be used inside <AuthProvider>.');
  return auth;
}
